import React from 'react'

import LetsTalkCta from '../LetsTalkCta'
import { getHomeAIValueLoopContent } from '../../constants/homeAIValueLoopContent'

const HomeAIValueLoop = ({ lang }) => {
  const content = getHomeAIValueLoopContent(lang)
  const isEn = lang === 'en'

  return (
    <section
      id="home-ai-value-loop"
      className="home-ai-value-loop"
      aria-labelledby="home-ai-value-loop-heading"
    >
      <div className="content container">
        <div className="home-ai-value-loop__card">
          <header className="home-ai-value-loop__intro">
            <h2 id="home-ai-value-loop-heading" className="home-ai-value-loop__intro-title">
              {content.introTitle}
            </h2>
            <p className="home-ai-value-loop__intro-lede">{content.introLede}</p>
          </header>

          <div className="home-ai-value-loop__body">
            <div className="home-ai-value-loop__copy">
              <h3 className="home-ai-value-loop__title">{content.title}</h3>
              <p className="home-ai-value-loop__text">{content.body}</p>
              <LetsTalkCta
                isEn={isEn}
                tone="onDark"
                paintDrip={false}
                to={content.cta.href}
                label={content.cta.label}
                className="home-ai-value-loop__cta"
              />
            </div>

            <ul className="home-ai-value-loop__highlights">
              {content.highlights.map(item => (
                <li key={item.id} className="home-ai-value-loop__highlight">
                  <span className="home-ai-value-loop__highlight-dot" aria-hidden="true" />
                  <span className="home-ai-value-loop__highlight-text">{item.text}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  )
}

export default HomeAIValueLoop
